<ng-container *ngIf="!!formGroup">
  <div class="responsive-card" [formGroup]="formGroup">
    <div class="d-flex flex-column gap-4">
      <div class="d-flex gap-1 flex-column">
        <div class="responsive-card-title" i18n>{{ jurisdictionName$ | async }} Spousal Waiver</div>
      </div>

      <div formArrayName="waivers" class="d-flex flex-column gap-4">
        <ng-container *ngFor="let entry of waiverControls$ | async; let i = index; trackBy: trackByWaiver">
          <div class="waiver-entry d-flex flex-column gap-3" [formGroupName]="i">
            <div class="waiver-grid">
              <div class="d-flex flex-column gap-1 waiver-grid-type">
                <label class="form-input-label" [for]="'spousalWaiverType' + i" i18n>Waiver Type</label>
                <app-dropdown-input
                  formControlName="spousalWaiverType"
                  [controlId]="'spousalWaiverType' + i"
                  [dropdowns]="((waiverTypeDropdownsByIndex$ | async) ?? [])[i] ?? []"
                  [error]="formSubmitted && entry.controls.spousalWaiverType.invalid"
                  inlineClearText="Clear"
                  i18n-inlineClearText />
                <app-form-error
                  *ngIf="formSubmitted && entry.controls.spousalWaiverType.invalid"
                  [errors]="entry.controls.spousalWaiverType.errors"
                  [customErrorMessages]="customErrorMessages.spousalWaiverType" />
              </div>
              <div class="d-flex flex-column gap-2 waiver-grid-date-signed">
                <label [for]="'spousalWaiverDateSigned' + i" class="form-input-label" i18n>Date Signed</label>
                <app-datepicker-input
                  formControlName="spousalWaiverDateSigned"
                  [controlId]="'spousalWaiverDateSigned' + i"
                  [error]="formSubmitted && entry.controls.spousalWaiverDateSigned.invalid" />
                <app-form-error
                  *ngIf="formSubmitted && entry.controls.spousalWaiverDateSigned.invalid"
                  [customErrorMessages]="customErrorMessages.spousalWaiverDateSigned"
                  [errors]="entry.controls.spousalWaiverDateSigned.errors" />
              </div>
              <div class="d-flex flex-column gap-2 waiver-grid-effective-date">
                <label [for]="'spousalWaiverEffectiveDate' + i" class="form-input-label" i18n>Effective Date</label>
                <app-datepicker-input
                  formControlName="spousalWaiverEffectiveDate"
                  [controlId]="'spousalWaiverEffectiveDate' + i"
                  [error]="formSubmitted && entry.controls.spousalWaiverEffectiveDate.invalid" />
                <app-form-error
                  *ngIf="formSubmitted && entry.controls.spousalWaiverEffectiveDate.invalid"
                  [customErrorMessages]="customErrorMessages.spousalWaiverEffectiveDate"
                  [errors]="entry.controls.spousalWaiverEffectiveDate.errors" />
              </div>
            </div>

            <ng-container *ngIf="existingFilesAsSubmissionAttachments[i] as existingFile; else fileUploader">
              <app-file-list-item
                [fileName]="existingFile.attachment.fileName"
                [fileSizeInBytes]="existingFile.attachment.fileSize"
                [showLabel]="false"
                [previewUrl]="existingFile.attachment.links | attachmentLink"
                action="remove"
                (removeClicked)="removeExistingWaiverFile(i, existingFile)" />
            </ng-container>

            <ng-template #fileUploader>
              <app-file-upload-field
                formControlName="spousalDeclaration"
                [control]="entry.controls.spousalDeclaration"
                [inputName]="'spousalDeclaration' + i"
                [accept]="['image/png', 'image/jpeg', 'application/pdf']"
                [maxFileSizeInMb]="3"
                [showThumbnail]="true">
                <ng-container input-copy>
                  <img height="24" src="assets/icons/grey/FileUpload.svg" alt="Upload File" i18n-alt />
                  <app-file-uploader-text descriptionText=".png, .jpeg, or .pdf up to 3 MB" i18n-descriptionText />
                </ng-container>
                <app-form-error
                  input-error
                  class="d-flex mt-2"
                  *ngIf="formSubmitted && entry.controls.spousalDeclaration.invalid"
                  [customErrorMessages]="customErrorMessages.spousalDeclaration"
                  [errors]="entry.controls.spousalDeclaration.errors" />
              </app-file-upload-field>
            </ng-template>

            <button *ngIf="i > 0" (click)="removeWaiver(i)" type="button" class="no-style-button remove-button" i18n>
              Remove Waiver Type
            </button>
          </div>
        </ng-container>
      </div>

      <button
        *ngIf="canAddWaiver$ | async"
        (click)="addWaiver()"
        type="button"
        class="add-button link-button no-style-button">
        <img src="assets/icons/primary/Plus.svg" alt="" [height]="18" [width]="18" />
        <div i18n>Add Another</div>
      </button>
    </div>
  </div>
</ng-container>
